import { render, staticRenderFns } from "./SocialStatuseInfo.vue?vue&type=template&id=15070698&"
import script from "./SocialStatuseInfo.vue?vue&type=script&lang=js&"
export * from "./SocialStatuseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports